import React from 'react';
import styled from 'styled-components';
import { BodyText, BoldHeader3Text, ModalWindow, Grid, FlexRow, Button, SwitchDialogWindows } from 'ui-toolkit';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { useApplicationContext } from '../../../../state';
import { Form, Formik } from 'formik';
import { CancelOrderReasonInput } from '../../../../ui-toolkit/orders/components/CancelOrder/CancelOrderReasonInput';
import { cancelOrderSchema } from '../../../../ui-toolkit/orders/components/CancelOrder/cancelOrderSchema';
import { IOrderDetailsData } from '../../../../ui-toolkit/orders/interfaces/IOrderDetailsData';

const StyledDiv = styled.div`
  display: grid;
  gap: ${(props) => props.theme.spacing.spacing5};
  text-align: left;
  width: 450px;
`;

const StyledBodyText = styled(BodyText)`
  padding-bottom: ${(props) => props.theme.spacing.spacing5};
`;

interface ICancelOrderModalProps {
  order: IOrderDetailsData;
  onCancelOrder: (reason?: string) => void;
  closeDialog: () => void;
  cancellationFetchStatus: IFetchStatus;
  cancellationError: Error | null;
}

export const CancelOrderModal: React.FC<ICancelOrderModalProps> = ({
  order,
  onCancelOrder,
  closeDialog,
  cancellationFetchStatus,
  cancellationError,
}) => {
  const [context] = useApplicationContext();
  const initialValue: { reason?: string } = {};
  return context.showCancelConfirmDialog ? (
    <SwitchDialogWindows
      onCloseClick={closeDialog}
      isCompleted={cancellationFetchStatus.fetched}
      isLoading={cancellationFetchStatus.fetching}
      isError={cancellationFetchStatus.fetched && !!cancellationError}
      successTitle={'Order cancelled'}
      errorMessage={cancellationError && cancellationError.message}
    >
      <ModalWindow uitype={'fit'} onClose={closeDialog}>
        <StyledDiv>
          <BoldHeader3Text>Canceling Order?</BoldHeader3Text>
          <StyledBodyText>
            Cancelling the order for {order.property.street_address} {order.transaction.file_number} sets the status to
            cancelled and surfaces this status to the client. Final actions to cancel the order will remain available.
          </StyledBodyText>
          <Formik
            initialValues={initialValue}
            validateOnMount={true}
            validationSchema={cancelOrderSchema(false)}
            onSubmit={(value) => {
              onCancelOrder(value.reason);
            }}
            onReset={closeDialog}
          >
            {({ isValid }) => (
              <Form>
                <Grid>
                  <CancelOrderReasonInput fieldName={'reason'} />
                  <FlexRow justifyContent={'flex-end'}>
                    <FlexRow>
                      <Button intent={'danger'} type={'submit'} disabled={!isValid}>
                        Yes, Cancel Order
                      </Button>
                      <Button intent={'ghost'} isInline type={'reset'}>
                        No, I've changed my mind
                      </Button>
                    </FlexRow>
                  </FlexRow>
                </Grid>
              </Form>
            )}
          </Formik>
        </StyledDiv>
      </ModalWindow>
    </SwitchDialogWindows>
  ) : null;
};
